const entryActions = ['connect', 'disconnect'];
const tenantPattern = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export const quickBooksGuidePath = '/billing/quickbooks/how-it-works';

export const quickBooksSettingsPath = (search = '') => {
  const params = new URLSearchParams(search);
  params.set('tab', 'quickbooks');
  return `/billing/settings?${params}`;
};

export const quickBooksEntryPath = (action) => (entryActions.includes(action)
  ? `/integrations/quickbooks/${action}`
  : null);

export const quickBooksEntryAction = (pathname) => entryActions.find((action) => (
  pathname === quickBooksEntryPath(action) || pathname === `${quickBooksEntryPath(action)}/`
)) || null;

export const quickBooksConnectionAction = (value) => (entryActions.includes(value)
  ? value
  : null);

export const quickBooksAppOrigin = (domain, protocol = 'https:') => {
  const origin = new URL(`https://${domain}`);
  if (!domain || origin.host !== domain || origin.pathname !== '/' || origin.search || origin.hash || origin.username || origin.password) {
    throw new Error('The Questri application domain is not configured correctly.');
  }
  if (origin.hostname === 'localhost' && protocol === 'http:') origin.protocol = 'http:';
  return origin.origin;
};

export const quickBooksBarnUrl = (tenant, action, domain, protocol) => {
  if (!tenantPattern.test(tenant || '') || !entryActions.includes(action)) throw new Error('Choose a valid Questri barn.');
  const url = new URL(quickBooksAppOrigin(domain, protocol));
  url.hostname = `${tenant}.${url.hostname}`;
  url.pathname = '/billing/settings';
  url.searchParams.set('tab', 'quickbooks');
  url.searchParams.set('connectionAction', action);
  return url.href;
};
